export const getFirstNameInitial = (fullName) => {
  if (!fullName) return "?";
  const parts = fullName.trim().split(" ");
  return parts[0][0]?.toUpperCase() || "?";
};

export const formatDate = (isoString, timeZone) => {
  if (!isoString) return "";
  return new Date(isoString).toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    ...(timeZone && { timeZone }),
  });
};

export const formatTime = (isoString, timeZone) => {
  if (!isoString) return "";
  return new Date(isoString).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    ...(timeZone && { timeZone }),
  });
};

export const formatDuration = (minutes) => {
  if (!minutes) return null;
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours === 0) return `${mins} min`;
  if (mins === 0) return `${hours} hour${hours !== 1 ? "s" : ""}`;
  return `${hours} hr ${mins} min`;
};
